export default __webpack_public_path__ + "static/media/melanzane.c1f8cc46.mp3";